fx.ns("shared.popups", class ErrorInsufficientMemory extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personNotHappy );

        this.contentWidth = 550;
        this.contentHeight = 225;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:fx.text("Mémoire insuffisante"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("Votre navigateur rencontre un problème de mémoire insuffisante. Veuillez le redémarrer pour régler le problème."), className:"text center"}));

        this.addFooterChild("close");
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onClose, this.closeBtn);
    }

    onClose()
    {
        super.onClose();

        this.data.event("show-editor");
        this.data.event("save-creation");
        // TODO : event for saving book.
    }
});